import {Spin} from 'antd'

export function Loading() {
  return <Spin data-testid="loading" fullscreen size="large" />
}
